export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
export const API_ENDPOINTS = {
  USERS: '/api/users',
  USER_ME: '/api/users/me',
  USER_AVATAR: '/api/users/me/avatar',
  USER_USERNAME: '/api/users/me/username',
  CHECK_USERNAME: (username) => `/api/users/check-username/${username}`
};

export const FILE_UPLOAD = {
  MAX_SIZE: 5 * 1024 * 1024, // 5MB
  VALID_TYPES: ['image/jpeg', 'image/png', 'image/webp']
};

export const USERNAME = {
  MIN_LENGTH: 3,
  MAX_LENGTH: 20,
  PATTERN: /^[a-zA-Z0-9_-]+$/
};